class InfiniteScroll {
  constructor() {
    this.productGrid = document.querySelector('#product-grid');
    this.container = document.querySelector('.product-grid-container');
    
    if (!this.productGrid || !this.container) return;
    
    this.loading = false;
    this.nextPageUrl = this.getNextPageUrl();
    
    // Ocultar la paginación original
    const pagination = document.querySelector('.pagination');
    if (pagination) {
      pagination.style.display = 'none';
    }
    
    this.init();
  }
  
  init() {
    window.addEventListener('scroll', this.handleScroll.bind(this));
  }
  
  getNextPageUrl() {
    const pagination = document.querySelector('.pagination');
    if (!pagination) return null;
    
    const nextLink = pagination.querySelector('a[aria-label*="siguiente"]') || 
                     pagination.querySelector('a[aria-label*="next"]') ||
                     pagination.querySelector('.pagination__item--next a');
    
    return nextLink ? nextLink.href : null;
  }
  
  handleScroll() {
    if (this.loading || !this.nextPageUrl) return;
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.body.offsetHeight - 800;
    
    if (scrollPosition >= threshold) {
      this.loadMore();
    }
  }
  
  async loadMore() {
    this.loading = true;
    this.showLoadingIndicator();
    
    try {
      const response = await fetch(this.nextPageUrl);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Obtener los nuevos productos
      const newProducts = doc.querySelectorAll('#product-grid .grid__item');
      
      // Añadir los nuevos productos al grid existente
      newProducts.forEach(product => {
        this.productGrid.appendChild(product.cloneNode(true));
      });
      
      // Actualizar la URL de la siguiente página
      const newPagination = doc.querySelector('.pagination');
      if (newPagination) {
        const nextLink = newPagination.querySelector('a[aria-label*="siguiente"]') || 
                        newPagination.querySelector('a[aria-label*="next"]') ||
                        newPagination.querySelector('.pagination__item--next a');
        this.nextPageUrl = nextLink ? nextLink.href : null;
      } else {
        this.nextPageUrl = null;
      }
      
      // Si no hay más páginas, mostrar mensaje
      if (!this.nextPageUrl) {
        this.showEndMessage();
      }
      
    } catch (error) {
      console.error('Error al cargar más productos:', error);
    }
    
    this.hideLoadingIndicator();
    this.loading = false;
  }
  
  showLoadingIndicator() {
    const loader = document.createElement('div');
    loader.className = 'infinite-scroll-loader';
    loader.innerHTML = '<p style="text-align: center; padding: 2rem;">Cargando más productos...</p>';
    loader.id = 'infinite-scroll-loader';
    this.container.appendChild(loader);
  }
  
  hideLoadingIndicator() {
    const loader = document.getElementById('infinite-scroll-loader');
    if (loader) {
      loader.remove();
    }
  }
  
  showEndMessage() {
    const endMessage = document.createElement('div');
    endMessage.className = 'infinite-scroll-end';
    endMessage.innerHTML = '<p style="text-align: center; padding: 2rem; color: #999;">Has visto todos los productos</p>';
    this.container.appendChild(endMessage);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
});